export default {
  uploadImg() {
    return "/uploading/uploadImg";
  },
  download() {
    return "https://afuwa-transfert.com/uploading/download";
  },
};
